import axios from "axios";
import { reactive, toRefs } from "vue";

const state = reactive({
    user: {},
	session: {},
	account: {},
    is_logged_in: false,
    login_expired: false,
    loading: false,
    initialised: false,
});

let axios_interceptor = null;

export default function useAuthStore() {
	
	const check = async () => {

		if(!state.initialised){	

			axios.interceptors.response.use(function (response) {
				return response;
			}, function (error) {
				if((error.response||{}).status == 401){
					state.login_expired = true;
					logout();
				}
				return Promise.reject(error);
			});
			
			await restoreState();
		}

        return !!state.is_logged_in;
    }
	
	const restoreState = async ( token = null ) => {
		const existing_token = token || localStorage.getItem('access_token');
		if(existing_token){
            state.session.access_token = existing_token;
            state.loading = true;
			state.user = (await axios.get('/me',{
                headers:{
                    Authorization : 'Bearer '+state.session.access_token,
				},
			})).data.data;
            state.loading = false;
			state.initialised = true;
		}
		updateLoginState();
    }
	
	const updateLoginState = () => {
		
		state.is_logged_in = !!(state.session||{}).access_token;

		state.account = (state.user.accounts||[])[0] || null;

		// Inject authorisation into axios requests if available
		if(!!state.session.access_token){
			axios_interceptor = axios.interceptors.request.use(function (config) {
				config.headers.Authorization =  'Bearer '+state.session.access_token;			
				return config;
			});
		} else {
			if(axios_interceptor){
				axios.interceptors.request.eject(axios_interceptor);
				axios_interceptor = null;
			}
		}

		return state.is_logged_in;
    }
	
	const attemptLogin = async (payload, referrer) => {
		state.loading = true;

		return await axios({
			method:'post',
			url:'login',
			data:payload,
            params: {
                referrer
            }
		}).then(({data})=>{
			state.loading = false;
			processLoginResponse(data);
		}).catch(e=>{
			state.loading = false;
			if(e.response.status == 400){
				throw new Error('Incorrect email or password entered');
			} else {
				throw e;
			}
		});
	}
	
	const logout = async ()=>{
		
		if(state.session.access_token){
            try {
                await axios.post('logout');
            } catch (e) {
                console.error('Server-side logout failed: Session already ended on server.');
            }
		}
        
    	state.initialised = false;
        localStorage.clear();
		state.session = {};
		state.user = {};
		updateLoginState();

	}
	
	const processLoginResponse = (response_data) => {
		if(response_data.accessToken && response_data.user){
			state.session.access_token = response_data.accessToken;
			state.user = response_data.user;

			localStorage.setItem('access_token',state.session.access_token);

			updateLoginState();
			return true;
		} else {
			return false;
		}
    }

    return {
        ...toRefs(state), // convert to refs when returning
        restoreState,
        logout,
        attemptLogin,
        processLoginResponse,
        check,
    }
}